<template>
  <div :style="styles" class="fb-layout-view" :id="element.uuid" v-if="mode">
        <component
          v-for="(el, index) in element.list"
          :uuid="el.uuid"
          :nid="nid"
          :sid="sid"
          :main_sid="main_sid"
          :key="el.uuid"
          :is="el.type"
          :element="el"
          :mode="1"
          :validate="validate"
          :active="active"
          :step="element.uuid"
          :countFormCards="countFormCards"
          :is-draft="isDraft"
          :status="status"
          :showSubmit="showSubmit"
          :validationFails="validation"
          @submit="$emit('submit')"
          @validation="updateValidation(index, $event)"
          @validate-form="$emit('validate-form')"
          @disable-form-validation="$emit('disable-form-validation')"
          @submit-draft="$emit('submit-draft', $event)"
          @autosave-start="$emit('autosave-start')"
          @autosave-stop="$emit('autosave-stop')"
          @set-value="$emit('set-value', $event)"
        ></component>
  </div>
  <div v-else class="fb-layout-view" :style="styles">
    <md-card class="md-elevation-2 md-layout-item md-primary fb-step">
    <fb-controll
      :controll="saveData.label || 'Layout'"
      @collapse-click="collapsePreview"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <md-field>
        <label>{{ tempData.label | token_replace(nid) }}</label>
      </md-field>
      <draggable
        @change="updateList"
        class="dragArea full-height"
        tag="div"
        :list="list"
        group="controls"
        :class="{'show-draggable': !list.length}"
      >
        <component
          v-for="(element, index) in list"
          @save-data="updateData(index, $event)"
          @menu-delete="removeItem(index)"
          :uuid="element.uuid"
          :key="element.uuid"
          :is="element.type"
          :element="element"
          :mode="0"
          :validate="validate"
        ></component>
      </draggable>
    </md-content>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field class="fb-select">
          <label for="movie">Width</label>
          <md-select v-model="tempData.width">
            <md-option value="25">25%</md-option>
            <md-option value="50">50%</md-option>
            <md-option value="75">75%</md-option>
            <md-option value="100">100%</md-option>
          </md-select>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
    </md-card>
  </div>
</template>

<script>
import FbStep from "./FbStep.vue";

export default {
  name: "FbLayout",
  props: [
    "element",
    "mode",
    "stepIndex",
    "steps",
    "active",
    "validate-last-step",
    "countFormCards",
    "status",
    "showSubmit",
    "validate"
  ],
  mixins: [FbStep],
  computed: {
    styles() {
      return {
        float: 'left',
        width: this.saveData.width + '%'
      }
    },
    valid: {
      cache: false,
      get() {
        if (this.isDraft) {
          return true;
        }
        let errors = this.validation.filter(el => {
          return el !== true;
        });
        return errors.length == 0;
      }
    }
  },
  created() {
    this.$emit("validation", this.valid);
  },
  data() {
    return {
      tempData: {
        label: this.element.data.label || "",
        value: this.element.data.value || false,
        width: this.element.data.width || "100"
      },
      saveData: {
        label: this.element.data.label || "",
        value: this.element.data.value || false,
        width: this.element.data.width || "100"
      },
      validation: [],
      list: this.element.list || []
    };
  },
  methods: {
    updateValidation(index, event) {
      this.validation[index] = event;
      this.validation = this.validation.slice(0);
      this.$emit("validation", this.valid);
    }
  }
};
</script>

<style lang="scss" scoped>
.dragArea {
  padding-bottom: 10px;
  position: relative;
  z-index: 99;
  // &::before {
  //   content: "DragAndDrop";
  //   display: block;
  //   position: absolute;
  //   top: 50%;
  //   text-align: center;
  //   width: 100%;
  // }
  min-height: 100px;
  background-color: rgba(255, 255, 255, 0.05);
}
</style>
<style lang="scss">
.dragArea > .md-card {
  float: left;
  width: 100%
}
.dragArea {
  &::after {
    clear: both;
    content: '';
    display: block;
  }
}
.fb-layout-view {
  padding: 0px 10px;
}
</style>
